export const selectAlerts = (state) => state.alerts

export const selectDeepfakeAlerts = (state) => state.alerts.deepfake

export const selectDeepfakeAlertTimestamp = (state) =>
  state.alerts.deepfake.newLiveAlertsSinceLastVisitTimestamp

export const selectAlertsError = (state) => state.alerts.error
